import script from "./MoveUserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoveUserCard.vue?vue&type=script&setup=true&lang=ts"

import "./MoveUserCard.vue?vue&type=style&index=0&id=72bb8bfb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72bb8bfb"]])

export default __exports__